/* RESPONSIBLE TEAM: team-frontend-tech */
import type AppService from 'embercom/services/app-service';
import type RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import IntercomRoute from 'embercom/routes/base/intercom-route';

export default class HomeRoute extends IntercomRoute {
  @service declare appService: AppService;
  @service declare intercomEventService: $TSFixMe;
  @service declare router: RouterService;

  get app() {
    return this.appService.app;
  }

  async beforeModel() {
    if (this.app.canUseFeature('team-self-serve-ai-onboarding')) {
      this.router.replaceWith('apps.app.operator');
    } else {
      this.router.transitionTo('apps.app.getting-started', this.app.id);
    }
    this.intercomEventService.trackEvent('nco_visited_home');
  }
}
